import React, { cloneElement, ReactElement, useEffect, useRef, useState } from 'react';
import { Transition, TransitionStatus } from 'react-transition-group';
import type { TransitionProps as BaseTransitionProps } from 'react-transition-group/Transition';
import type { CSSProperties } from 'styled-components/dist/types';

type TransitionStyles = Partial<Record<'default' | TransitionStatus, CSSProperties>>;

export type TransitionProps = Partial<BaseTransitionProps> & {
    timeout?: number;
    children: ReactElement;
};

export const makeTransitionComponent =
    (stylesFactory: (timeout: number) => TransitionStyles) => (props: TransitionProps) => {
        const { timeout = 150, children, ...other } = props;
        const [isAppeared, setIsAppeared] = useState(false);
        const transitionStylesRef = useRef<TransitionStyles>(stylesFactory(timeout));

        useEffect(() => {
            setIsAppeared(true);
        }, []);

        return (
            <Transition in={isAppeared} {...other} timeout={timeout}>
                {(state: TransitionStatus) =>
                    cloneElement(children, {
                        style: {
                            ...transitionStylesRef.current.default,
                            ...(isAppeared
                                ? transitionStylesRef.current[state]
                                : transitionStylesRef.current.entering),
                        },
                    })
                }
            </Transition>
        );
    };
